import { useQuery } from 'react-query'
import FarmerGroupsService from '~/api/services/farmerGroups'
import { onError } from '~/utils/helpers'

const getFarmersList = (module?) => useQuery(
  'get-farmer-group-list-trading',
  () => FarmerGroupsService.getFarmerGroupsList(module),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmersGroupsList = (module?) => useQuery(
  'get-farmer-modules-group-list-trading',
  () => FarmerGroupsService.farmerGroupsWithModulesList(module),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmersListOrganization = (isOrganization?) => useQuery(
  'get-farmer-group-list-organization',
  () => FarmerGroupsService.getFarmerGroupsListOrganization(isOrganization),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerGroupsList = (data) => useQuery(
  `get-farmers-groups-list-${data.search}`,
  () => FarmerGroupsService.getFarmerGroupsIndex(data),
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerGroupsOptionData = () => useQuery(
  'get-farmers-groups-list-options',
  FarmerGroupsService.getFarmerGroupsOptionsData,
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerGroupsShowData = (id: string) => useQuery(
  'show-farmers-groups-data',
  () => FarmerGroupsService.showFarmerGroup(id),
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const FarmerGroupQuery = {
  getFarmersList,
  getFarmerGroupsList,
  getFarmerGroupsOptionData,
  getFarmersListOrganization,
  getFarmerGroupsShowData,
  getFarmersGroupsList
}

export default FarmerGroupQuery
